import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Products", href: "/#products" },
  { label: "About", href: "/#about" },
  { label: "Founders", href: "/founders" },
  { label: "Contact", href: "/#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-zinc-800/80 bg-black/60 backdrop-blur-md" data-testid="navbar">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-12">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo-mark.png" alt="Omkaar Metals logo" className="h-10 w-10 object-contain" />
          <span className="flex items-baseline gap-2">
            <span className="font-display text-xl font-semibold uppercase tracking-wide text-zinc-100">Omkaar</span>
            <span className="font-mono-label text-[10px] text-copper">Metals Ltd</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-label text-[11px] text-zinc-400 transition-colors duration-300 hover:text-copper-light"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            data-testid="nav-quote-btn"
            className="group flex items-center gap-1 bg-copper px-4 py-2 font-mono-label text-[11px] text-ink transition-colors duration-300 hover:bg-copper-light"
          >
            Get a Quote
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>

        <button
          className="text-zinc-200 md:hidden"
          onClick={() => setOpen(!open)}
          data-testid="nav-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-zinc-800 bg-black/90 px-6 py-6 backdrop-blur-md md:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-mono-label text-xs text-zinc-300 transition-colors duration-300 hover:text-copper-light"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-quote-btn"
              className="mt-2 w-fit bg-copper px-5 py-2.5 font-mono-label text-xs text-ink transition-colors duration-300 hover:bg-copper-light"
            >
              Get a Quote
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};
